function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { v4 as uuid } from 'uuid';
import deepmerge from 'deepmerge';
import { AdvertsManager } from '../../../addons/adverts-manager';
import { ReportingManager } from '../../../addons/reporting/reporting-manager';
import { Proposition } from '../../../config/internal-config';
import { CoreVideoInternal } from '../../../core-video-internal';
import { sdkLogger } from '../../../logger';
import { createLoggingObservable } from '../../../utils/observables/verbose-logging-observable';
import { PerfKey, perfLogger, PerfTag } from '../../../utils/perf';
import { checkIsManifestLinearType, checkIsManifestVodType } from '../../../utils/playback-type';
import { DvrWindowDuration, PlaybackType } from '../../player/playout-data';
import { getMaxVideoFormat, getSupportedColourSpaces, getMaxFrameRate } from '../../player/video-format';
import { PrefetchItem } from '../prefetch/prefetch-item';
import { isRawSessionItem, SessionController } from '../session-controller';
import { InternalSessionState } from '../internal-session-state';
import { SessionControllerInternal } from '../session-controller-internal';
import { SessionControllerInternalProxy } from '../session-controller-internal-proxy';
import { arraysAreEqual, overwriteMerge } from '../../../utils/array-utils';
import { VideoStartupController } from '../video-startup/video-startup-controller';
import { VideoStartupStates } from '../video-startup/video-startup-states';
import { PineManager } from '../../../addons/pine/pine-manager';
import { SessionEventTracker } from '../session-event-tracker';
import { getPreferredTrackFromMetadata } from '../../../utils/select-track';
export var SessionControllerPrecursor = /*#__PURE__*/ function() {
    "use strict";
    function SessionControllerPrecursor(videoPlatformIntegration, _sessionItem, addonsFactories, internalConfig, playerPrecursorEngine, engineCreationOptions, playerEngine, hdcpManager) {
        _class_call_check(this, SessionControllerPrecursor);
        var _this_sessionConfig_addons, _this_sessionConfig_vpi, _this_sessionConfig_vpi_tokenService, _this_sessionConfig_vpi1, _this_sessionConfig_addons_pine, _this_sessionConfig_addons1, _this_sessionConfig_addons2, _this_addonsFactories_ituQualityAssessment, _this_addonsFactories;
        _define_property(this, "videoPlatformIntegration", void 0);
        _define_property(this, "_sessionItem", void 0);
        _define_property(this, "addonsFactories", void 0);
        _define_property(this, "playerPrecursorEngine", void 0);
        _define_property(this, "engineCreationOptions", void 0);
        _define_property(this, "playerEngine", void 0);
        _define_property(this, "hdcpManager", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "sessionProxy", void 0);
        _define_property(this, "advertsManager", void 0);
        _define_property(this, "initialisePromise", void 0);
        _define_property(this, "reportingManager", void 0);
        _define_property(this, "sessionAttachedObservable", void 0);
        _define_property(this, "sessionConfig", void 0);
        _define_property(this, "sessionId", void 0);
        _define_property(this, "videoStartupController", void 0);
        _define_property(this, "playoutSessionItem", void 0);
        _define_property(this, "pineManager", void 0);
        _define_property(this, "ituQualityAssessmentAddon", void 0);
        _define_property(this, "prefetchItem", void 0);
        _define_property(this, "unregisterPostPrefetchSubtitlesObserver", void 0);
        _define_property(this, "unregisterPostPrefetchAudioObserver", void 0);
        _define_property(this, "sessionController", void 0);
        _define_property(this, "sessionEventTracker", void 0);
        this.videoPlatformIntegration = videoPlatformIntegration;
        this._sessionItem = _sessionItem;
        this.addonsFactories = addonsFactories;
        this.playerPrecursorEngine = playerPrecursorEngine;
        this.engineCreationOptions = engineCreationOptions;
        this.playerEngine = playerEngine;
        this.hdcpManager = hdcpManager;
        this.logger = sdkLogger.withContext('Precursor');
        this.sessionProxy = new SessionControllerInternalProxy();
        this.initialisePromise = null;
        this.sessionAttachedObservable = createLoggingObservable('SessionAttached', this.logger);
        this.sessionId = self.crypto.randomUUID ? self.crypto.randomUUID() : uuid();
        this.unregisterPostPrefetchSubtitlesObserver = undefined;
        this.unregisterPostPrefetchAudioObserver = undefined;
        this.sessionEventTracker = new SessionEventTracker(this.sessionProxy);
        this.sessionConfig = deepmerge({}, internalConfig);
        this._sessionItem = this.populateSessionItem(this._sessionItem);
        this.advertsManager = new AdvertsManager((_this_sessionConfig_addons = this.sessionConfig.addons) === null || _this_sessionConfig_addons === void 0 ? void 0 : _this_sessionConfig_addons.adInsertion, this.sessionProxy, addonsFactories, this.videoPlatformIntegration.getUMVToken(), ((_this_sessionConfig_vpi = this.sessionConfig.vpi) === null || _this_sessionConfig_vpi === void 0 ? void 0 : _this_sessionConfig_vpi.useCustomVpip) ? undefined : (_this_sessionConfig_vpi1 = this.sessionConfig.vpi) === null || _this_sessionConfig_vpi1 === void 0 ? void 0 : (_this_sessionConfig_vpi_tokenService = _this_sessionConfig_vpi1.tokenService) === null || _this_sessionConfig_vpi_tokenService === void 0 ? void 0 : _this_sessionConfig_vpi_tokenService.getToken);
        this.reportingManager = new ReportingManager(this.sessionProxy, addonsFactories.reporting, this.sessionItem);
        if ((_this_sessionConfig_addons1 = this.sessionConfig.addons) === null || _this_sessionConfig_addons1 === void 0 ? void 0 : (_this_sessionConfig_addons_pine = _this_sessionConfig_addons1.pine) === null || _this_sessionConfig_addons_pine === void 0 ? void 0 : _this_sessionConfig_addons_pine.enabled) {
            var _this_sessionConfig_addons3;
            this.pineManager = new PineManager((_this_sessionConfig_addons3 = this.sessionConfig.addons) === null || _this_sessionConfig_addons3 === void 0 ? void 0 : _this_sessionConfig_addons3.pine, this.addonsFactories);
        }
        this.ituQualityAssessmentAddon = (_this_addonsFactories_ituQualityAssessment = (_this_addonsFactories = this.addonsFactories).ituQualityAssessment) === null || _this_addonsFactories_ituQualityAssessment === void 0 ? void 0 : _this_addonsFactories_ituQualityAssessment.call(_this_addonsFactories, (_this_sessionConfig_addons2 = this.sessionConfig.addons) === null || _this_sessionConfig_addons2 === void 0 ? void 0 : _this_sessionConfig_addons2.ituQualityAssessment, this.sessionEventTracker, this.sessionProxy);
        this.videoStartupController = new VideoStartupController(this.advertsManager, this.videoStartupEngineStarterOptions);
        if (Boolean(this.playerEngine)) {
            this.bootstrapSession();
        }
        this.sessionController = new SessionController(this.sessionProxy, this.sessionConfig);
        this.sessionProxy.onSessionEnded(this.handleSessionEnded.bind(this));
    }
    _create_class(SessionControllerPrecursor, [
        {
            key: "populateSessionItem",
            value: /**
     * Populate session item with default values
     * Note: Modifies session item in place
     * @param sessionItem
     * @returns SessionItem
     */ function populateSessionItem(sessionItem) {
                var _sessionItem_reporting, _this_sessionConfig, _sessionItem_addonsConfigOverride, _sessionItem_reporting1, _sessionItem_reporting2;
                var defaultAttributes = {
                    sessionId: this.sessionId,
                    autoplay: true,
                    isMiniPlayer: false,
                    user: {},
                    reporting: {
                        userWatchedAt: new Date()
                    },
                    preferredAudioMetadata: [],
                    preferredAudioLanguages: [],
                    preferredSubtitleMetadata: [],
                    preferredSubtitlesLanguages: [],
                    liveEdgeToleranceSeconds: 40,
                    vac: {
                        coppaApplies: false
                    }
                };
                sessionItem = deepmerge(defaultAttributes, sessionItem);
                // TODO: This is only a temporary workaround and will be removed in the future. For now every linear channel is exclusive. This is also something specific to Peacock/SkyShowtime
                if (sessionItem.type === PlaybackType.Live && ((_sessionItem_reporting = sessionItem.reporting) === null || _sessionItem_reporting === void 0 ? void 0 : _sessionItem_reporting.assetMetadata) && [
                    Proposition.Peacock,
                    Proposition.SkyShowtime
                ].includes((_this_sessionConfig = this.sessionConfig) === null || _this_sessionConfig === void 0 ? void 0 : _this_sessionConfig.proposition)) {
                    sessionItem.reporting.assetMetadata.isExclusiveChannel = true;
                }
                if (!sessionItem.videoFormatConfig) {
                    sessionItem.videoFormatConfig = {};
                }
                var compatibleStreamPropertyGroup = CoreVideoInternal.getCompatibleStreamPropertyGroupForPlaybackType(sessionItem.type);
                sessionItem.videoFormatConfig.support = {
                    maxVideoFormat: getMaxVideoFormat(sessionItem, CoreVideoInternal.deviceInfo, compatibleStreamPropertyGroup),
                    supportedColourSpaces: getSupportedColourSpaces(sessionItem, CoreVideoInternal.deviceInfo, compatibleStreamPropertyGroup),
                    maxFrameRate: getMaxFrameRate(sessionItem, CoreVideoInternal.deviceInfo, compatibleStreamPropertyGroup)
                };
                if ((_sessionItem_addonsConfigOverride = sessionItem.addonsConfigOverride) === null || _sessionItem_addonsConfigOverride === void 0 ? void 0 : _sessionItem_addonsConfigOverride.adInsertion) {
                    this.sessionConfig.addons.adInsertion = deepmerge(sessionItem.adInsertion, sessionItem.addonsConfigOverride.adInsertion);
                    sessionItem.adInsertion = deepmerge(sessionItem.adInsertion, sessionItem.addonsConfigOverride.adInsertion);
                }
                if ((_sessionItem_reporting1 = sessionItem.reporting) === null || _sessionItem_reporting1 === void 0 ? void 0 : _sessionItem_reporting1.videoInitiate) {
                    this.logger.warn('Deprecated: Need to move videoInitiate from reporting object to root of sessionItem');
                }
                sessionItem.videoInitiate = ((_sessionItem_reporting2 = sessionItem.reporting) === null || _sessionItem_reporting2 === void 0 ? void 0 : _sessionItem_reporting2.videoInitiate) || sessionItem.videoInitiate;
                return sessionItem;
            }
        },
        {
            key: "attachOnBeforeRetryHandler",
            value: function attachOnBeforeRetryHandler() {
                var _this = this;
                this.videoStartupController.onRestartSessionInitiatedHandler(function(restartOptions) {
                    var sessionItemOverrides = restartOptions.sessionItemOverrides;
                    var sessionItem = deepmerge(_this.sessionItem, sessionItemOverrides, {
                        arrayMerge: overwriteMerge
                    });
                    if (checkIsManifestVodType(_this.sessionItem.type) && !sessionItem.startPosition) {
                        var advertsAdjustedStartPosition = _this.advertsManager.getVodStartPositionAfterCurrentAdvert();
                        if (advertsAdjustedStartPosition) {
                            restartOptions.playoutDataOverrides.position = advertsAdjustedStartPosition;
                        }
                    }
                    _this.advertsManager.finishCurrentAd(_this.sessionProxy);
                    _this.reset(sessionItem);
                    return restartOptions;
                });
            }
        },
        {
            key: "updateSessionItem",
            value: function updateSessionItem(newSessionItem) {
                this.playoutSessionItem = this.populateSessionItem(newSessionItem);
            }
        },
        {
            key: "onSessionAttached",
            value: function onSessionAttached(callback) {
                this.sessionAttachedObservable.registerObserver(callback, this);
            }
        },
        {
            key: "onTelemetryUpdate",
            value: function onTelemetryUpdate(callback) {
                this.videoStartupController.onTelemetryUpdate(callback);
            }
        },
        {
            key: "getPrefetchStage",
            value: // TODO - review the need for that accessor instead of keeping prefetch stage inside the playoutData
            function getPrefetchStage() {
                var _this_prefetchItem;
                return (_this_prefetchItem = this.prefetchItem) === null || _this_prefetchItem === void 0 ? void 0 : _this_prefetchItem.getLastPrefetchStage();
            }
        },
        {
            key: "isPrefetchedSession",
            value: function isPrefetchedSession() {
                return Boolean(this.prefetchItem);
            }
        },
        {
            key: "isPrefetching",
            value: function isPrefetching() {
                return this.isPrefetchedSession() && !this.prefetchItem.isPrefetchLocked;
            }
        },
        {
            key: "getSessionProxy",
            value: function getSessionProxy() {
                return this.sessionProxy;
            }
        },
        {
            key: "getPlayerEngine",
            value: function getPlayerEngine() {
                return this.playerEngine;
            }
        },
        {
            key: "setPlayerEngine",
            value: function setPlayerEngine(playerEngine) {
                this.playerEngine = playerEngine;
            }
        },
        {
            key: "isRetryEnabled",
            value: function isRetryEnabled() {
                var _CoreVideoInternal_display, _this_sessionItem_display, _this_sessionItem_sessionRetryConfig;
                var colourSpaceRetryEnabled = ((_CoreVideoInternal_display = CoreVideoInternal.display) === null || _CoreVideoInternal_display === void 0 ? void 0 : _CoreVideoInternal_display.activateColourSpace) && ((_this_sessionItem_display = this.sessionItem.display) === null || _this_sessionItem_display === void 0 ? void 0 : _this_sessionItem_display.playerViewAlwaysPresentedFullScreen);
                var vpfRetryEnabled = (_this_sessionItem_sessionRetryConfig = this.sessionItem.sessionRetryConfig) === null || _this_sessionItem_sessionRetryConfig === void 0 ? void 0 : _this_sessionItem_sessionRetryConfig.enabled;
                var qualityFailoverEnabled = Boolean(this.sessionItem.enableQualityFailover);
                return colourSpaceRetryEnabled || vpfRetryEnabled || qualityFailoverEnabled;
            }
        },
        {
            key: "createSession",
            value: function createSession() {
                var propositionExtensions = CoreVideoInternal.getPropositionExtensions();
                var controller = new SessionControllerInternal(this.playerEngine, this.sessionConfig, this.videoPlatformIntegration, this, propositionExtensions.addonFactories, this.hdcpManager);
                this.videoStartupController.setSessionControllerInternal(controller);
            }
        },
        {
            key: "bootstrapSession",
            value: function bootstrapSession() {
                if (this.isRetryEnabled()) {
                    this.createRetriableSession();
                } else {
                    this.createSession();
                }
            }
        },
        {
            key: "startSession",
            value: function startSession() {
                this.videoStartupController.startSession();
            }
        },
        {
            key: "restartSession",
            value: function restartSession() {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this.videoStartupController.restart()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "initialise",
            value: function initialise(pin) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.initialisePromise) {
                                    return [
                                        2,
                                        _this.initialisePromise
                                    ];
                                }
                                _this.initialisePromise = _this._initialise(pin);
                                return [
                                    4,
                                    _this.initialisePromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "playoutData",
            get: function get() {
                return this.videoStartupController.cachedModifiedPlayoutData;
            }
        },
        {
            key: "ovpOriginalPlayoutData",
            get: function get() {
                return this.videoStartupController.cachedOvpOriginalPlayoutData;
            }
        },
        {
            key: "mainAsset",
            get: function get() {
                var _this_videoStartupController_engineStarter;
                return (_this_videoStartupController_engineStarter = this.videoStartupController.engineStarter) === null || _this_videoStartupController_engineStarter === void 0 ? void 0 : _this_videoStartupController_engineStarter.mainAsset;
            }
        },
        {
            key: "sessionItem",
            get: function get() {
                return this._sessionItem;
            }
        },
        {
            key: "modifyPlayoutDataForCdnSwitch",
            value: function modifyPlayoutDataForCdnSwitch(playoutData) {
                var newCdnPlayoutData = _object_spread({}, playoutData, this.getCdnSwitchStartPosition(playoutData));
                return this.advertsManager.modifyPlayoutDataForCdnSwitch(newCdnPlayoutData);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_pineManager, _this_ituQualityAssessmentAddon;
                    return _ts_generator(this, function(_state) {
                        _this.videoStartupController.destroy();
                        _this.reportingManager.destroy();
                        _this.advertsManager.destroy();
                        (_this_pineManager = _this.pineManager) === null || _this_pineManager === void 0 ? void 0 : _this_pineManager.destroy();
                        (_this_ituQualityAssessmentAddon = _this.ituQualityAssessmentAddon) === null || _this_ituQualityAssessmentAddon === void 0 ? void 0 : _this_ituQualityAssessmentAddon.destroy();
                        _this.initialisePromise = null;
                        _this.sessionAttachedObservable.unregisterObservers(_this);
                        _this.sessionProxy.destroy();
                        _this.sessionEventTracker.destroy();
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "reset",
            value: function reset(sessionItem) {
                var _this_sessionConfig_addons, _this_sessionConfig_vpi, _this_sessionConfig_vpi_tokenService, _this_sessionConfig_vpi1;
                this._sessionItem = sessionItem;
                this.initialisePromise = null;
                this.advertsManager.destroy();
                this.advertsManager = new AdvertsManager((_this_sessionConfig_addons = this.sessionConfig.addons) === null || _this_sessionConfig_addons === void 0 ? void 0 : _this_sessionConfig_addons.adInsertion, this.sessionProxy, this.addonsFactories, this.videoPlatformIntegration.getUMVToken(), ((_this_sessionConfig_vpi = this.sessionConfig.vpi) === null || _this_sessionConfig_vpi === void 0 ? void 0 : _this_sessionConfig_vpi.useCustomVpip) ? undefined : (_this_sessionConfig_vpi1 = this.sessionConfig.vpi) === null || _this_sessionConfig_vpi1 === void 0 ? void 0 : (_this_sessionConfig_vpi_tokenService = _this_sessionConfig_vpi1.tokenService) === null || _this_sessionConfig_vpi_tokenService === void 0 ? void 0 : _this_sessionConfig_vpi_tokenService.getToken);
                this.videoStartupController.setAdvertsManager(this.advertsManager);
            }
        },
        {
            key: "createPlayerEngineItem",
            value: function createPlayerEngineItem(engine, modifiedPlayoutData, advertBoltOns, drmBoltOns) {
                return this.videoStartupController.engineStarter.createPlayerEngineItem(engine, modifiedPlayoutData, advertBoltOns, drmBoltOns);
            }
        },
        {
            key: "createRetriableSession",
            value: function createRetriableSession() {
                var _this = this;
                var propositionExtensions = CoreVideoInternal.getPropositionExtensions();
                // Retry controller needs factory to create new session when retrying
                var sessionControllerInternalFactory = function() {
                    var controller = new SessionControllerInternal(_this.playerEngine, _this.sessionConfig, _this.videoPlatformIntegration, _this, propositionExtensions.addonFactories, _this.hdcpManager);
                    return controller;
                };
                this.videoStartupController.createRestartController(this.sessionProxy, this.sessionItem, sessionControllerInternalFactory);
                this.attachOnBeforeRetryHandler();
            }
        },
        {
            key: "handleSessionEnded",
            value: function handleSessionEnded() {
                this.destroy();
            }
        },
        {
            key: "attachSession",
            value: function attachSession(session) {
                var _this = this;
                var _session_waitForState;
                this.sessionProxy.attachSession(session);
                this.notifySessionAttached(this.sessionController);
                if (this.playoutSessionItem) {
                    this.handlePostPrefetchSessionUpdates(session);
                }
                if (!this.reportingManager.initialised) {
                    this.reportingManager.initialise();
                }
                (_session_waitForState = session.waitForState(InternalSessionState.Loading)) === null || _session_waitForState === void 0 ? void 0 : _session_waitForState.then(function() {
                    _this.sessionProxy.handleSessionStarted();
                });
            }
        },
        {
            key: "getAdvertsManager",
            value: function getAdvertsManager() {
                return this.advertsManager;
            }
        },
        {
            key: "getReportingAddons",
            value: function getReportingAddons() {
                return this.reportingManager.getReportingAddons();
            }
        },
        {
            key: "adaptPlayerError",
            value: function adaptPlayerError(error) {
                return this.videoPlatformIntegration.adaptPlayerError(error);
            }
        },
        {
            key: "getDRMBoltOns",
            value: function getDRMBoltOns() {
                if (!CoreVideoInternal.capabilities.requiresLicensingSigning()) {
                    return {};
                }
                if (!CoreVideoInternal.playerCapabilities.hasLicensingSigning) {
                    throw Error('The selected player can not perform license signing');
                }
                return {
                    decorateLicenseRequest: this.videoPlatformIntegration.decorateLicenseRequest
                };
            }
        },
        {
            key: "handlePostPrefetchSessionUpdates",
            value: function handlePostPrefetchSessionUpdates(session) {
                var _this = this;
                if (!this.prefetchItem) {
                    this._sessionItem = this.playoutSessionItem;
                } else if (!this.unregisterPostPrefetchSubtitlesObserver) {
                    // Post-prefetch session item changes
                    this.unregisterPostPrefetchSubtitlesObserver = session.onAvailableSubtitlesTracksChanged(function(tracks) {
                        _this.handlePostPrefetchSubtitles(tracks);
                    });
                    this.unregisterPostPrefetchAudioObserver = session.onAvailableAudioTracksChanged(function(tracks) {
                        _this.handlePostPrefetchAudio(tracks);
                    });
                }
            }
        },
        {
            key: "findTargetTrack",
            value: function findTargetTrack(availableTracks, preferredLanguages) {
                var targetTrack = undefined;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _loop = function() {
                        var preferredLang = _step.value;
                        targetTrack = availableTracks.find(function(track) {
                            return track.language === preferredLang || track.languageTag === preferredLang;
                        });
                        if (targetTrack) {
                            return "break";
                        }
                    };
                    for(var _iterator = (preferredLanguages !== null && preferredLanguages !== void 0 ? preferredLanguages : [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = _loop();
                        if (_ret === "break") break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return targetTrack;
            }
        },
        {
            key: "handlePostPrefetchAudio",
            value: function handlePostPrefetchAudio(tracks) {
                var _this_playoutSessionItem, _this_playoutSessionItem1, _this_playoutSessionItem2, _this_playoutSessionItem3, _this_unregisterPostPrefetchAudioObserver, _this;
                var targetTrack;
                if (!arraysAreEqual(this.sessionItem.preferredAudioMetadata, (_this_playoutSessionItem = this.playoutSessionItem) === null || _this_playoutSessionItem === void 0 ? void 0 : _this_playoutSessionItem.preferredAudioMetadata)) {
                    var _this_playoutSessionItem4;
                    targetTrack = getPreferredTrackFromMetadata((_this_playoutSessionItem4 = this.playoutSessionItem) === null || _this_playoutSessionItem4 === void 0 ? void 0 : _this_playoutSessionItem4.preferredAudioMetadata, tracks);
                }
                if (!targetTrack && !arraysAreEqual(this.sessionItem.preferredAudioLanguages, (_this_playoutSessionItem1 = this.playoutSessionItem) === null || _this_playoutSessionItem1 === void 0 ? void 0 : _this_playoutSessionItem1.preferredAudioLanguages)) {
                    var _this_playoutSessionItem5;
                    targetTrack = this.findTargetTrack(tracks, (_this_playoutSessionItem5 = this.playoutSessionItem) === null || _this_playoutSessionItem5 === void 0 ? void 0 : _this_playoutSessionItem5.preferredAudioLanguages);
                }
                if (targetTrack) {
                    this.sessionProxy.setAudioTrack(targetTrack.id);
                }
                this.sessionItem.preferredAudioMetadata = (_this_playoutSessionItem2 = this.playoutSessionItem) === null || _this_playoutSessionItem2 === void 0 ? void 0 : _this_playoutSessionItem2.preferredAudioMetadata;
                this.sessionItem.preferredAudioLanguages = (_this_playoutSessionItem3 = this.playoutSessionItem) === null || _this_playoutSessionItem3 === void 0 ? void 0 : _this_playoutSessionItem3.preferredAudioLanguages;
                (_this_unregisterPostPrefetchAudioObserver = (_this = this).unregisterPostPrefetchAudioObserver) === null || _this_unregisterPostPrefetchAudioObserver === void 0 ? void 0 : _this_unregisterPostPrefetchAudioObserver.call(_this);
            }
        },
        {
            key: "handlePostPrefetchNewSubtitlesMetadata",
            value: function handlePostPrefetchNewSubtitlesMetadata(tracks) {
                var _this_playoutSessionItem, _this_playoutSessionItem_preferredSubtitleMetadata, _this_playoutSessionItem1, _this_playoutSessionItem2;
                if (!((_this_playoutSessionItem = this.playoutSessionItem) === null || _this_playoutSessionItem === void 0 ? void 0 : _this_playoutSessionItem.preferredSubtitleMetadata) || ((_this_playoutSessionItem1 = this.playoutSessionItem) === null || _this_playoutSessionItem1 === void 0 ? void 0 : (_this_playoutSessionItem_preferredSubtitleMetadata = _this_playoutSessionItem1.preferredSubtitleMetadata) === null || _this_playoutSessionItem_preferredSubtitleMetadata === void 0 ? void 0 : _this_playoutSessionItem_preferredSubtitleMetadata.length) === 0) {
                    this.sessionProxy.disableSubtitles();
                    return false;
                }
                var targetTrack = this.findTargetTrack(tracks, (_this_playoutSessionItem2 = this.playoutSessionItem) === null || _this_playoutSessionItem2 === void 0 ? void 0 : _this_playoutSessionItem2.preferredSubtitleMetadata.map(function(psm) {
                    return psm.languageTag;
                }));
                if (targetTrack) {
                    this.sessionProxy.enableSubtitles(targetTrack.id);
                }
                return true;
            }
        },
        {
            key: "handlePostPrefetchNewSubtitlesLanguages",
            value: function handlePostPrefetchNewSubtitlesLanguages(tracks) {
                var _this_playoutSessionItem, _this_playoutSessionItem_preferredSubtitlesLanguages, _this_playoutSessionItem1, _this_playoutSessionItem2;
                if (!((_this_playoutSessionItem = this.playoutSessionItem) === null || _this_playoutSessionItem === void 0 ? void 0 : _this_playoutSessionItem.preferredSubtitlesLanguages) || ((_this_playoutSessionItem1 = this.playoutSessionItem) === null || _this_playoutSessionItem1 === void 0 ? void 0 : (_this_playoutSessionItem_preferredSubtitlesLanguages = _this_playoutSessionItem1.preferredSubtitlesLanguages) === null || _this_playoutSessionItem_preferredSubtitlesLanguages === void 0 ? void 0 : _this_playoutSessionItem_preferredSubtitlesLanguages.length) === 0) {
                    this.sessionProxy.disableSubtitles();
                    return false;
                }
                var targetTrack = this.findTargetTrack(tracks, (_this_playoutSessionItem2 = this.playoutSessionItem) === null || _this_playoutSessionItem2 === void 0 ? void 0 : _this_playoutSessionItem2.preferredSubtitlesLanguages);
                if (targetTrack) {
                    this.sessionProxy.enableSubtitles(targetTrack.id);
                }
                return true;
            }
        },
        {
            key: "handlePostPrefetchSubtitles",
            value: function handlePostPrefetchSubtitles(tracks) {
                var _this_playoutSessionItem, _this_playoutSessionItem1, _this_playoutSessionItem2, _this_playoutSessionItem3, _this_unregisterPostPrefetchSubtitlesObserver, _this;
                if (!arraysAreEqual(this.sessionItem.preferredSubtitleMetadata, (_this_playoutSessionItem = this.playoutSessionItem) === null || _this_playoutSessionItem === void 0 ? void 0 : _this_playoutSessionItem.preferredSubtitleMetadata)) {
                    var hadPreferredSubs = this.handlePostPrefetchNewSubtitlesMetadata(tracks);
                    if (!hadPreferredSubs) {
                        return;
                    }
                }
                if (!arraysAreEqual(this.sessionItem.preferredSubtitlesLanguages, (_this_playoutSessionItem1 = this.playoutSessionItem) === null || _this_playoutSessionItem1 === void 0 ? void 0 : _this_playoutSessionItem1.preferredSubtitlesLanguages)) {
                    var hadPreferredLanguage = this.handlePostPrefetchNewSubtitlesLanguages(tracks);
                    if (!hadPreferredLanguage) {
                        return;
                    }
                }
                this.sessionItem.preferredSubtitleMetadata = (_this_playoutSessionItem2 = this.playoutSessionItem) === null || _this_playoutSessionItem2 === void 0 ? void 0 : _this_playoutSessionItem2.preferredSubtitleMetadata;
                this.sessionItem.preferredSubtitlesLanguages = (_this_playoutSessionItem3 = this.playoutSessionItem) === null || _this_playoutSessionItem3 === void 0 ? void 0 : _this_playoutSessionItem3.preferredSubtitlesLanguages;
                (_this_unregisterPostPrefetchSubtitlesObserver = (_this = this).unregisterPostPrefetchSubtitlesObserver) === null || _this_unregisterPostPrefetchSubtitlesObserver === void 0 ? void 0 : _this_unregisterPostPrefetchSubtitlesObserver.call(_this);
            }
        },
        {
            key: "getCdnSwitchStartPosition",
            value: function getCdnSwitchStartPosition(cdnSwitchPlayoutData) {
                var _cdnSwitchPlayoutData_cdns_ = cdnSwitchPlayoutData.cdns[0], newStreamInfo = _cdnSwitchPlayoutData_cdns_.streamInfo;
                var _this_ovpOriginalPlayoutData_cdns_ = this.ovpOriginalPlayoutData.cdns[0], originalStreamInfo = _this_ovpOriginalPlayoutData_cdns_.streamInfo;
                if (checkIsManifestLinearType(cdnSwitchPlayoutData.type) && newStreamInfo && originalStreamInfo) {
                    if ('windowDuration' in newStreamInfo && 'windowDuration' in originalStreamInfo && originalStreamInfo.windowDuration !== DvrWindowDuration.Restricted && newStreamInfo.windowDuration === DvrWindowDuration.Restricted) {
                        return {
                            linearPosition: undefined
                        };
                    }
                }
                return {
                    position: this.ovpOriginalPlayoutData.position
                };
            }
        },
        {
            key: "notifySessionAttached",
            value: function notifySessionAttached(currentSession) {
                this.sessionAttachedObservable.notifyObservers(currentSession);
                // This should only be fired once per precursor, so unregister here just to be safe
                this.sessionAttachedObservable.unregisterObservers(this);
            }
        },
        {
            key: "getPrefetchItem",
            value: function getPrefetchItem() {
                return this.prefetchItem;
            }
        },
        {
            key: "videoStartupEngineStarterOptions",
            get: function get() {
                return {
                    sessionConfig: this.sessionConfig,
                    advertsManager: this.advertsManager,
                    playerPrecursorEngine: this.playerPrecursorEngine,
                    engineCreationOptions: this.engineCreationOptions,
                    sessionId: this.sessionId,
                    sessionProxy: this.sessionProxy,
                    drmBoltons: this.getDRMBoltOns(),
                    pineManager: this.pineManager
                };
            }
        },
        {
            key: "prefetch",
            value: function prefetch(destroyHandler, includeAdsPrefetchWhenPossible) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_sessionConfig_addons_pine, _this_sessionConfig_addons, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!((_this_sessionConfig_addons = _this.sessionConfig.addons) === null || _this_sessionConfig_addons === void 0 ? void 0 : (_this_sessionConfig_addons_pine = _this_sessionConfig_addons.pine) === null || _this_sessionConfig_addons_pine === void 0 ? void 0 : _this_sessionConfig_addons_pine.enabled)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.pineManager.connect()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                _this.prefetchItem = new PrefetchItem(_this.videoStartupController, _this.videoPlatformIntegration, _this.sessionItem, destroyHandler, includeAdsPrefetchWhenPossible);
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    5,
                                    ,
                                    6
                                ]);
                                return [
                                    4,
                                    _this.prefetchItem.prefetch()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                e = _state.sent();
                                _this.prefetchItem = undefined;
                                throw e;
                            case 6:
                                return [
                                    2,
                                    _this.prefetchItem
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_initialise",
            value: // eslint-disable-next-line complexity -- This method is long, but it's easy to follow. Most of the bulk is from the continuous isDestroyed checks.
            function _initialise(pin) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_prefetchItem, _this_sessionConfig_addons_pine, _this_sessionConfig_addons, uninitialisedStates, isVamCalled, e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Finish the prefetch promise before continuing
                                return [
                                    4,
                                    (_this_prefetchItem = _this.prefetchItem) === null || _this_prefetchItem === void 0 ? void 0 : _this_prefetchItem.lockPrefetchStage()
                                ];
                            case 1:
                                _state.sent();
                                if (!((_this_sessionConfig_addons = _this.sessionConfig.addons) === null || _this_sessionConfig_addons === void 0 ? void 0 : (_this_sessionConfig_addons_pine = _this_sessionConfig_addons.pine) === null || _this_sessionConfig_addons_pine === void 0 ? void 0 : _this_sessionConfig_addons_pine.enabled)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.pineManager.connect()
                                ];
                            case 2:
                                _state.sent();
                                _this.pineManager.init(_this.sessionItem, _this.videoStartupEngineStarterOptions.sessionProxy);
                                _state.label = 3;
                            case 3:
                                if (_this.videoStartupController.state.type() === VideoStartupStates.EngineStarted) {
                                    return [
                                        2
                                    ];
                                }
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    17,
                                    ,
                                    18
                                ]);
                                if (pin && !isRawSessionItem(_this._sessionItem)) {
                                    _this._sessionItem.parentalControlPin = pin;
                                }
                                uninitialisedStates = [
                                    VideoStartupStates.Uninitialised,
                                    VideoStartupStates.Discarded,
                                    VideoStartupStates.Retried
                                ];
                                if (uninitialisedStates.includes(_this.videoStartupController.state.type())) {
                                    _this.videoStartupController.initialise();
                                }
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.Initialised)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    _this.videoStartupController.callVideoProvider(_this._sessionItem, _this.videoPlatformIntegration, false)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                if (_this.videoStartupController.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (_this.videoStartupController.state.type() === VideoStartupStates.VideoProviderCalled) {
                                    _this.videoStartupController.initialiseAdverts(_this._sessionItem);
                                }
                                if (_this.videoStartupController.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (!_this.videoStartupController.shouldSkipAdvertisements) return [
                                    3,
                                    8
                                ];
                                return [
                                    4,
                                    _this.videoStartupController.startEngine(_this.sessionItem)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    2
                                ];
                            case 8:
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.AdvertsInitialised)) return [
                                    3,
                                    10
                                ];
                                return [
                                    4,
                                    _this.videoStartupController.callVam(_this._sessionItem)
                                ];
                            case 9:
                                isVamCalled = _state.sent();
                                if (isVamCalled && Boolean(_this.videoStartupController.cachedModifiedPlayoutData.vamFailureStatus)) {
                                    _this.videoStartupController.skipAdvertisement();
                                }
                                _state.label = 10;
                            case 10:
                                if (_this.videoStartupController.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.VamCalled)) return [
                                    3,
                                    12
                                ];
                                return [
                                    4,
                                    _this.videoStartupController.bootstrapAds()
                                ];
                            case 11:
                                _state.sent();
                                _state.label = 12;
                            case 12:
                                if (!(!_this.videoStartupController.shouldSkipAdvertisements && _this.videoStartupController.state.type() === VideoStartupStates.AdsBootstrapped)) return [
                                    3,
                                    14
                                ];
                                return [
                                    4,
                                    _this.videoStartupController.callAdsData()
                                ];
                            case 13:
                                _state.sent();
                                perfLogger.measure(PerfKey.root, PerfTag.playoutModified);
                                _state.label = 14;
                            case 14:
                                if (_this.videoStartupController.isDestroyed) {
                                    return [
                                        2
                                    ];
                                }
                                if (!(_this.videoStartupController.state.type() === VideoStartupStates.AdsInsertionCalled)) return [
                                    3,
                                    16
                                ];
                                return [
                                    4,
                                    _this.videoStartupController.startEngine(_this.sessionItem)
                                ];
                            case 15:
                                _state.sent();
                                _state.label = 16;
                            case 16:
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                e = _state.sent();
                                _this.initialisePromise = null;
                                _this.videoStartupController.discard();
                                throw e;
                            case 18:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SessionControllerPrecursor;
}();

//# sourceMappingURL=session-controller-precursor.js.map